
    <i *ngFor="let amenity of amenitiesFiltered"
      class="icon venue-amenity-icon"
      [mdl-tooltip]="amenityTooltip(amenity)"
      mdl-tooltip-position="top"
      [ngClass]="amenityIcon(amenity)"></i>
  